import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { CiCalendar } from "react-icons/ci";
import { SlLocationPin } from "react-icons/sl";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase/utils";
import { createEventByUser, setLocation } from "../../redux/posts/posts.action";

const PreviewEvent = ({ isOpen, previous, close, closePreview, callBack }) => {
  const [uploadDataLoading, setUploadLoading] = useState(false);
  const darktheme = useSelector((state) => state.features.settings.darktheme);

  const [imageUrl, setImageUrl] = useState([]);
  const [percent, setPercent] = useState(0);
  const { uploadLoading, eventData, activeLocation } = useSelector(
    (state) => state.posts
  );

  const dispatch = useDispatch();

  const handleUploadData = () => {
    setUploadLoading(true);

    uploadImage(eventData?.imageArray[0]);
  };

  useEffect(() => {
    if (percent === 100) {
      handleSubmit();
    }
    // eslint-disable-next-line
  }, [imageUrl]);

  const uploadImage = (file) => {
    if (!file) {
      alert("Please choose a file");
    } else {
      const storageRef = ref(storage, `/images/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );

          setPercent(percent);
        },
        (err) => console.log(err),
        () => {
          getDownloadURL(uploadTask.snapshot.ref)
            .then((url) => {
              if (url) {
                setImageUrl([url]);
              }
            })
            .catch((err) => console.log(err));
        }
      );
    }
  };

  const handleSubmit = () => {
    const payload = {
      lat: eventData?.latitude,
      lng: eventData?.longitude,
      title: eventData?.title,

      description: eventData?.text,
      pictures: imageUrl,
      date: eventData?.date,
      time: eventData?.time,
      address: activeLocation,
    };

    dispatch(createEventByUser(payload));

    if (uploadLoading === false) {
      dispatch(setLocation(""));
      setUploadLoading(false);
      callBack();
      close();
    }
  };

  return (
    <>
      <Modal
        className="w-full "
        size={"lg"}
        isOpen={isOpen}
        onClose={() => closePreview()}
        onOverlayClick={() => close(false)}
      >
        <ModalOverlay />
        <ModalContent
          className=" max-w-[552px]  h-[524px]"
          containerProps={{ justifyContent: "center", alignItems: "center" }}
          borderRadius={30}
        >
          <div
            className={`${
              darktheme ? "bg-kdark3 rounded-[16px]" : "bg-white rounded-[20px]"
            } h-full py-[22px]`}
          >
            <div className="flex  px-[20px] relative items-center w-full">
              {previous ? (
                <div className="w-[36px] absolute cursor-pointer  h-[36px] float-left bg-[#ffffff] border-[.1px] rounded-full my-[1rem]  justify-center flex items-center">
                  <FaArrowLeft
                    size={12}
                    className="float-left text-[#050558]"
                  />
                </div>
              ) : (
                <div
                  onClick={closePreview}
                  className={`w-[36px] absolute cursor-pointer  h-[36px] float-left ${
                    darktheme ? "bg-black text-[#888a8b] " : "bg-white "
                  } border-[.1px] rounded-full my-[rem]  justify-center flex items-center`}
                >
                  <FaTimes
                    size={12}
                    className={`float-left text-[#050558] ${
                      darktheme ? "text-[#888a8b] " : "text-[#050558] "
                    }`}
                  />
                </div>
              )}

              <h4
                className={`text-center mx-auto  font-[500] text-[14px] ${
                  darktheme ? "text-[#888a8b]" : "text-[#FC5059]"
                }`}
              >
                Create Event
              </h4>
            </div>
            <ModalBody className="my-[16px]  w-full">
              <div>
                <p className=" font-[400] my-[16px] text-[16px] text-[#718096]  ">
                  Here's a preview of your event
                </p>
                <div className="py-[8px] border-[1px] border-[#E2E4E9] px-[8px] rounded-[16px] w-full my-[12px]  h-[307px]">
                  <div className=" mr-[.5rem] w-full  h-[209px] mb-2 rounded-[10px]">
                    {eventData?.imageArray && (
                      <div
                        className="relative rounded-[10px] h-full w-full "
                        // onClick={() => deleteImage(i)}
                      >
                        <img
                          src={URL.createObjectURL(eventData?.imageArray[0])}
                          alt="uploaded post files"
                          className="object-cover rounded-[10px] w-full h-full"
                        />
                      </div>
                    )}
                  </div>

                  <div className="flex-col -mt-1 h-[70px]">
                    <h4
                      className={`font-[700] mt-[12px] mb-[4px] text-[16px]  ${
                        darktheme ? "text-[#888a8b]" : "text-[#1c2024] "
                      } `}
                    >
                      {eventData?.title}
                    </h4>
                    <div className="flex mb-[4px]">
                      <CiCalendar
                        className={` w-[20px] h-[20px] ${
                          darktheme ? "text-[#888a8b]" : "text-[#040d14] "
                        } `}
                      />{" "}
                      <p className="text-[#60646C] font-[400] text-[12px] ml-1">
                        {eventData?.date} – {eventData?.time}
                      </p>
                    </div>
                    <div className="flex gap-[4px] ">
                      <SlLocationPin
                        className={` w-[20px] h-[20px]  ${
                          darktheme ? "text-[#888a8b]" : "text-[#040d14] "
                        }`}
                      />{" "}
                      <p className="text-[#60646C] font-[400] text-[12px]">
                        {activeLocation}
                      </p>
                    </div>
                  </div>
                </div>
                {uploadDataLoading ? (
                  <div className="w-[50px] h-[50px] bg-black rounded-[50%] mt-[5px] float-right">
                    <div className="lds-dual-ring bg-[red"></div>
                  </div>
                ) : (
                  <button
                    onClick={() => handleUploadData()}
                    className={`bg-[#E5484D]
                 rounded-[999px] py-[10px] px-[16px] w-[69px] h-[41px] my-[16px] text-[14px] text-white font-[500] float-right`}
                  >
                    Post
                  </button>
                )}
              </div>
            </ModalBody>
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PreviewEvent;
